import i18n from '@/i18n';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Notify from '@/components/Notification';
import { QUERY_KEYS } from '@/query/queryKeys';
import { loyaltyService } from '../../services/loyaltyService';

const { t } = i18n;

export const useSaveModerateReservation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      loyaltyService.reserve(payload).then(response => {
        const { status, data } = response;
        if (status === 201) {
          queryClient.refetchQueries({
            queryKey: [QUERY_KEYS.investing.status],
          });
          queryClient.refetchQueries({
            queryKey: [QUERY_KEYS.loyalty.reservation_limits],
          });
          Notify.success({
            text: t('kit:notify.amount_successfully_reserved'),
          });
          return { success: true, data };
        }
        return data;
      }),
  });
};
